import { __awaiter } from 'tslib';
import { Registry } from '@tencent/workbench-core';
import { InjectorService } from './injector-service.js';
import { ProviderRegistry } from './provider.js';

/**
 * @public
 */
class DynamicLoader {
    constructor(key) {
        this.key = key;
        this.loaded = false;
    }
    get instance() {
        return InjectorService.get(this.key);
    }
    getModule() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const mod = yield this.useFactory();
            if (!InjectorService.has(this.key)) {
                const options = ProviderRegistry.get(mod);
                InjectorService.set(Object.assign(Object.assign({}, options), { provide: this.key, useClass: mod }));
            }
            this.promise = null;
            this.loaded = true;
            (_a = this.onModuleLoad) === null || _a === void 0 ? void 0 : _a.call(this, mod);
            return mod;
        });
    }
    load() {
        if (this.promise) {
            return this.promise;
        }
        this.promise = this.getModule();
        return this.promise;
    }
    getInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (InjectorService.has(this.key)) {
                return this.instance;
            }
            yield this.load();
            return this.instance;
        });
    }
}
class LoaderRegistry extends Registry {
    constructor() {
        super(DynamicLoader);
        this.triggerMap = new Map();
    }
    merge(key, options) {
        super.merge(key, options);
        if (options.on) {
            const triggers = this.triggerMap.get(options.on);
            if (triggers && !triggers.resolved) {
                triggers.loaders.push(key);
            }
            else if (triggers === null || triggers === void 0 ? void 0 : triggers.resolved) {
                this.get(key).load();
            }
            else {
                this.triggerMap.set(options.on, { loaders: [key], resolved: false });
                options.on(() => new Promise((resolve) => {
                    const triggerOption = this.triggerMap.get(options.on);
                    triggerOption.resolved = true;
                    Promise.all(triggerOption.loaders.map(k => { var _a; return (_a = this.get(k)) === null || _a === void 0 ? void 0 : _a.load(); })).then(() => resolve());
                }));
            }
        }
    }
}
/**
 * 加载器注册中心
 *
 * @public
 */
const DynamicLoaderRegistry = new LoaderRegistry();

export { DynamicLoader, DynamicLoaderRegistry };
//# sourceMappingURL=dynamic-loader.js.map
